/* global angular */

/**
 * PreviewService
 *
 * Preview is enabled by configuring a variant containing the content types that should be
 * previewable. Expects the configured variant to return a content with an aspect, 'webPreview',
 * with the property 'contentPath' containing a path to be added to the configured 'previewBaseUrl'
 *
 */
angular.module('atex.aceui.service').factory('PreviewService',
  ['$q', 'ApplicationConfigurationService', 'ContentURLService',

    function ($q, ApplicationConfigurationService, ContentURLService) {
      return {
      /**
       * Gets a URL to be used for previewing content. Resolves to an object
       * containing one
       *
       * @param {string} workspace - the workspace to use for the preview
       * @param {string} alias - the alias of the content to get a preview for
       *
       * @return { url: string }
       * @throws atex.aceui.error.Error
       */
        async preview ({ alias, workspace }) {
          const previewConfig = await ApplicationConfigurationService.getServiceConfigurationFor ('PreviewService');
          const config = {
            aspectName: 'webPreview',
            baseURL: previewConfig.previewBaseUrl,
            variant: previewConfig.previewVariant,
            type: 'preview'
          };
          const response = await ContentURLService.getContentURL ({ alias, config, workspace });
          return $q.resolve (response);
        },
        /**
       * Checks whether a content is previewable. It is considered previewable
       * if we can fetch it in the configured preview variant on the given workspace.
       *
       * @param {string} alias - content to check whether previewable or not
       * @param {string} workspace - the workspace to fetch the content through
       *
       * @return {boolean}
       * @throws atex.aceui.error.Error
       */
        async isPreviewable ({ alias, workspace }) {
          try {
            const previewConfig = await ApplicationConfigurationService.getServiceConfigurationFor ('PreviewService');
            if (!previewConfig || !previewConfig.previewVariant) {
              console.info('No previewVariant configuration found. Content will not be previewable.');
              return $q.resolve (false);
            }
            const config = {
              aspectName: 'webPreview',
              baseURL: previewConfig.previewBaseUrl,
              variant: previewConfig.previewVariant
            };
            const response = await ContentURLService.getContentURL ({ alias, config, workspace });
            return $q.resolve (!!(response && response.url));
          } catch (error) {
            if (error.type === atex.aceui.error.types.NOT_FOUND) {
              return $q.resolve (false);
            }
            throw error;
          }
        }
      };
    }
  ]);
